export enum Bookmakers {
    FanDuel = 'FanDuel',
    DraftKings = 'DraftKings',
    BetMGM = 'BetMGM'
}